/**
 * Article Content Block - Frontend JavaScript
 * Copies the article link to the clipboard and gives temporary feedback.
 */
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const buttons = document.querySelectorAll('.article-content__copy-button');

        buttons.forEach(function (button) {
            const label = button.querySelector('span');
            const defaultText = label ? label.textContent : '';
            let resetTimer = null;

            async function copyLink() {
                const url = button.getAttribute('data-url') || window.location.href;

                try {
                    if (navigator.clipboard && window.isSecureContext) {
                        await navigator.clipboard.writeText(url);
                    } else {
                        // Fallback for non-secure contexts / older browsers
                        const textarea = document.createElement('textarea');
                        textarea.value = url;
                        textarea.style.position = 'fixed';
                        textarea.style.opacity = '0';
                        document.body.appendChild(textarea);
                        textarea.focus();
                        textarea.select();
                        document.execCommand('copy');
                        document.body.removeChild(textarea);
                    }

                    showCopied();
                } catch (err) {
                    // Silently ignore — nothing to copy if it fails
                }
            }

            function showCopied() {
                if (label) {
                    label.textContent = 'Copied';
                }
                button.classList.add('is-copied');

                if (resetTimer) {
                    clearTimeout(resetTimer);
                }

                resetTimer = setTimeout(function () {
                    if (label) {
                        label.textContent = defaultText;
                    }
                    button.classList.remove('is-copied');
                    resetTimer = null;
                }, 5000);
            }

            button.addEventListener('click', copyLink);
        });
    });
})();
